// extracted by mini-css-extract-plugin
module.exports = {"section_counsellor_list":"counsellor_list_section_counsellor_list__ruPbC"};